import { ICONS } from './icons';
import { CSS_TABLE_TOOLBAR, CSS_TABLE_TOOLBAR_BUTTON, CSS_TABLE_TOOLBAR_BUTTON_DANGER, CSS_TABLE_TOOLBAR_SEPARATOR, getTableContentRect } from './types';
export function createButton(icon, handler, isDanger = false) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `${CSS_TABLE_TOOLBAR_BUTTON}${isDanger ? ` ${CSS_TABLE_TOOLBAR_BUTTON_DANGER}` : ''}`;
    btn.innerHTML = icon;
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        handler();
    });
    return btn;
}
export function createSeparator() {
    const sep = document.createElement('span');
    sep.className = CSS_TABLE_TOOLBAR_SEPARATOR;
    return sep;
}
export function buildToolbarButtons(handlers, isWeekOverview) {
    const buttons = [];
    if (!isWeekOverview) {
        buttons.push(createButton(ICONS.insertRowAbove, handlers.insertRowAbove), createButton(ICONS.insertRowBelow, handlers.insertRowBelow), createSeparator(), createButton(ICONS.insertColumnLeft, handlers.insertColumnLeft), createButton(ICONS.insertColumnRight, handlers.insertColumnRight), createSeparator(), createButton(ICONS.deleteRow, handlers.deleteRow, true), createButton(ICONS.deleteColumn, handlers.deleteColumn, true), createSeparator());
    }
    buttons.push(createButton(ICONS.deleteTable, handlers.deleteTable, true));
    return buttons;
}
export function createToolbarElement(buttons) {
    const toolbar = document.createElement('div');
    toolbar.className = CSS_TABLE_TOOLBAR;
    buttons.forEach((btn) => toolbar.appendChild(btn));
    return toolbar;
}
export function positionToolbar(toolbarEl, table, editorContainer) {
    const containerRect = editorContainer.getBoundingClientRect();
    const contentRect = getTableContentRect(table);
    toolbarEl.style.top = `${contentRect.top - containerRect.top - toolbarEl.offsetHeight - 4}px`;
    toolbarEl.style.left = `${contentRect.left - containerRect.left}px`;
}
